import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Cylinder = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 2C10.393 2 6 4.636 6 8V24C6 27.364 10.393 30 16 30C21.607 30 26 27.364 26 24V8C26 4.636 21.607 2 16 2ZM10.122 5.339C11.676 4.476 13.763 4 16 4C18.237 4 20.325 4.475 21.878 5.339C23.226 6.088 24 7.058 24 8C24 8.942 23.227 9.912 21.878 10.661C20.324 11.524 18.237 12 16 12C13.763 12 11.675 11.525 10.122 10.661C8.774 9.912 8 8.942 8 8C8 7.058 8.773 6.088 10.122 5.339ZM21.878 26.661C20.324 27.524 18.237 28 16 28C13.763 28 11.675 27.525 10.122 26.661C8.774 25.912 8 24.942 8 24V11.641C9.81 13.083 12.693 14 16 14C19.307 14 22.19 13.083 24 11.641V24C24 24.942 23.227 25.912 21.878 26.661Z" />
	</svg>
);

export default Cylinder;
